<template>
  <div class="mt-4">
    <div class="card top_primary_card bg-primary font-bold text-white p-2 rounded-xl w-full">
      <div class="flex justify-center items-center">
        <h1 class="heading-2 text-center">Create Job</h1>
      </div>
    </div>
    <div class="flex justify-center">
      <div class="card rounded-xl bg-white p-4 my-4 sm:w-full lg:w-10/12 xl:w-8/12 2xl:w-6/12">
        <div class="p-4 pb-0">
          <!-- Customer & Location Section -->
          <div class="sm:grid grid-cols-2 gap-4">
            <div class="mb-4 sm:mb-0">
              <Dropdown
                :disabled="isDisable"
                :inputext="searchForCustomer"
                :inputId="'searchwp-Customer'"
                :lableText="'Customer'"
                :placholderText="'Customer'"
                :autoFocus="false"
                :showArrow="true"
                :setReadOnly="false"
                :searchCallApi="true"
                :fieldError="errObj.custErr !== ''"
                :showPlus="true"
                :keyName="'companyName'"
                :listId="'customerlistid'"
                :items="customersList"
                @enterkeyPressAction="errObj.custErr = ''"
                @inputChangeAction="callsearchCust"
                @addNew="addNewCustomer"
                @selectNewForVal="selectNewCustomer"
              />
              <p v-if="errObj.custErr !== ''" class="text-error heading-7">
                {{ errObj.custErr }}
              </p>
            </div>

            <!-- <div v-if="addJobObj.customerId > 0"></div> -->
            <div v-if="custDetail !== null" class="mb-4 sm:mb-0 flex items-center">
              <div v-if="custDetail.hotNotes !== ''" class="flex items-center ml-4 pt-2">
                <span @click="showAddNote = true" class="text-primary cursor-pointer">
                  <i class="fa-solid fa-pen-to-square h-5 w-5"></i>
                </span>
              </div>
              <div v-if="!showHotNote && custDetail.hotNotes !== ''" class="flex items-center px-4 pt-2">
                <span @click="showHotNote = true" class="text-primary cursor-pointer">Show Hot Notes</span>
                <InfoTooltip tooltipText="Hot notes is a note that shows next to customer all the time for you to get a quick information about the customer" position="right" class="ml-2"/>
              </div>
              <div v-else-if="showHotNote" class="flex items-center px-4 pt-2">
                <span @click="showHotNote = false" class="text-primary cursor-pointer">Hide Hot Notes</span>
                <InfoTooltip tooltipText="Hot notes is a note that shows next to customer all the time for you to get a quick information about the customer" position="right" class="ml-2"/>
              </div>
              <div v-else-if="custDetail.hotNotes === ''" class="flex items-center px-4 pt-2">
                <span @click="showAddNote = true" class="text-primary cursor-pointer">Enter Hot Notes</span>
                <InfoTooltip tooltipText="Hot notes is a note that shows next to customer all the time for you to get a quick information about the customer" position="right" class="ml-2"/>
              </div>
            </div>
            <div v-if="custDetail !== null && showHotNote" class="mb-4 sm:mb-0 flex items-center col-span-2">
              <p class="label_css">Hot Note</p><span style="width: 10px; margin-left: 5px;">: </span><p class="text-error"> {{ custDetail.hotNotes }}</p>
            </div>
            <!-- <div class="mb-4 sm:mb-0 flex items-center">
              <div class="flex items-center px-4 pt-2">
                <span @click="showAddNote = true" class="text-primary cursor-pointer">change</span>
              </div>
            </div> -->
            <div v-if="custDetail !== null" class="mb-4 sm:mb-0 col-span-2">
              <TextField
                :inputId="'jobtitlename'"
                :textMaxlength="100"
                :showcharLimit="true"
                :inputext="addJobObj.jobTitle"
                :fieldError="errObj.titleErr !== ''"
                :placholderText="'Job Title'"
                :lableText="'Job Title'"
                :autoFocus="false"
                @keyPressAction="errObj.titleErr = ''"
                @inputChangeAction="(data) => (addJobObj.jobTitle = data)"
              />
              <p class="text-error heading-7">{{ errObj.titleErr }}</p>
            </div>
            <div v-if="custDetail !== null" class="col-span-2 mb-0">
              <TextAreaInput
                :inputId="'jobdescriptioncon'"
                :inputext="stepTwoObj.jobDescription"
                :placholderText="'Write description here...'"
                :lableText="'Job Description'"
                :inputType="'text'"
                :autoFocus="false"
                :textMaxlength="1000"
                :showcharLimit="true"
                class="w-full"
                :setReadOnly="false"
                @inputChangeAction="(data) => (stepTwoObj.jobDescription = data)"
              />
            </div>
            <div v-if="custDetail !== null" class="col-span-2 mb-4 sm:mb-0">
              <p class="label_css flex">Select Job Type<InfoTooltip tooltipText="Job type will help you to categorize jobs based and will help you in reporting" position="right" class="ml-2"/></p>
              <div class="flex flex-wrap mt-2">
                <span v-for="(type, index) in jobTypeList" :key="index">
                  <span
                    @click="selectJobType(type)"
                    :class="`mb-1 cursor-pointer flex items-center justify-center w-fit heading-6 whitespace-nowrap border rounded-2xl text-${stepTwoObj.jobTypeId === type.jobTypeId ? 'primary' : ''} border-${stepTwoObj.jobTypeId === type.jobTypeId ? 'primary' : 'gray2'} px-2 py-1 mr-1`"
                  >
                    {{ type.jobTypeName }}
                  </span>
                </span>
              </div>
            </div>
            <div v-if="custDetail !== null" class="mb-4 sm:mb-0">
              <p class="label_css flex m-0 p-0">Billing <InfoTooltip tooltipText="Billable will remind you to generate bill before job completion Non Billable will not remind you to create bill on job completion Not application - not yet decided if this job will require billing" position="right" class="ml-2"/></p>
              
              <div class="flex flex-wrap mt-2 gap-4">
                <label class="flex items-center cursor-pointer">
                  <input
                    type="radio"
                    name="billingStatus"
                    :value="true"
                    v-model="stepTwoObj.isBillable"
                    class="mr-2 cursor-pointer"
                  />
                  <span class="heading-6">Billable</span>
                </label>
                <label class="flex items-center cursor-pointer">
                  <input
                    type="radio"
                    name="billingStatus"
                    :value="false"
                    v-model="stepTwoObj.isBillable"
                    class="mr-2 cursor-pointer"
                  />
                  <span class="heading-6">Not Billable</span>
                </label>
                <label class="flex items-center cursor-pointer">
                  <input
                    type="radio"
                    name="billingStatus"
                    :value="null"
                    v-model="stepTwoObj.isBillable"
                    class="mr-2 cursor-pointer"
                  />
                  <span class="heading-6">Not Applicable</span>
                </label>
              </div>
            </div>
          </div>
          <div v-if="custDetail !== null" class="flex space-x-10 col-span-2 mt-4 sm:mb-0">
            <div class="flex items-center py-1">
              <CheckBoxInput
              :checkValue="stepTwoObj.isVipJob"
              :label="'VIP Job'"
              :size="'small'"
              :disabled="false"
              @setIsActive="stepTwoObj.isVipJob = !stepTwoObj.isVipJob"
              />
              <InfoTooltip tooltipText="VIP Job will show a Star in job list and detail for you to know its an important job" position="right" class="ml-2"/>
            </div>
          </div>
          <div v-if="custDetail !== null" class="mb-4 sm:mb-0 col-span-2 mt-6">
            <Dropdown
              :disabled="!showAddSelectAddr"
              :lableText="'Job Location'"
              :placholderText="'Select job location'"
              :inputext="selectedAddressLabel"
              :showArrow="true"
              :setReadOnly="false"
              :searchCallApi="false"
              :fieldError="errObj.addressErr !== ''"
              :keyName="'label'"
              :autoFocus="false"
              :showPlus="true"
              :showClearIcon="true"
              :inputId="'address-dropdown'"
              :listId="'address-list'"
              :items="addressDropdownItems"
              @selectNewForVal="handleAddressSelect"
              @addNew="addNewAddress"
            />
            <p v-if="errObj.addressErr !== ''" class="text-error heading-7">
              {{ errObj.addressErr }}
            </p>

            <!-- Show distance below if selected -->
            <p v-if="selectedAddress && selectedAddress.type === 'customer'" class="text-text2 heading-7 mt-1">
              {{ selectedAddress.data.displayDistance }}
            </p>
            <p v-else-if="isOfficeAddressSel" class="text-text2 heading-7 mt-1">
              Office Location Selected
            </p>
            <p v-else-if="isAddedNewAddress" class="text-error heading-7 mt-1">
              {{ otherLocationDistance }}
            </p>

            <!-- Show "Add to customer" checkbox only for new address -->
            <div v-if="isAddedNewAddress" class="flex items-center mt-2">
              <CheckBoxInput
                :checkValue="addJobObj.isAddressAddToCustomer"
                :label="''"
                :size="'small'"
                :disabled="false"
                @setIsActive="addJobObj.isAddressAddToCustomer = !addJobObj.isAddressAddToCustomer"
              />
              <span class="pl-0 text-text2 cursor-pointer" @click.stop.prevent="addJobObj.isAddressAddToCustomer = !addJobObj.isAddressAddToCustomer">
                Add address in customer file
              </span>
            </div>
          </div>
          <!-- Description & Job Type Section -->
          <!-- <div class="divider mb-4 mt-4"></div> -->
          <!-- Schedule & Assignee Section -->
          <div v-if="custDetail !== null" class="grid grid-cols-2  mt-0">
            <!-- <div v-if="jobDetailObj" class="col-span-2">
              <span v-if="!stepTwoObj.isBillable">Non Billable</span>
              <span v-else>Billable</span> // {{ jobDetailObj.JobTypeName }} <br>
              <span>{{ displayDistance }}</span>
            </div> -->
            <div class="col-span-2 mt-4">
              <div class="card rounded-lg border border-gray2 bg-white overflow-hidden">
                <!-- Card Header - Non-clickable -->
                <div class="flex justify-between items-center p-4">
                  <div class="flex items-center">
                    <span class="heading-5 font-semibold text-text1">Schedule and User Assignment</span>
                  </div>
                </div>

                <!-- Card Body - Always visible -->
                <div class="border-t border-gray2">
                  <div class="p-4">
                    <SheduleVisit
                      :sTime="ssTime"
                      :eTime="eeTime"
                      :assignUser="assignUser"
                      :isFromSchedule="false"
                      :showEmployeeSelection="true"
                      :showJobItemSelection="false"
                      :visitErr="visitErr"
                      :jobDetail="jobDetailObj"
                      :isCreateJob="true"
                      :isShowJobSection="true"
                      :setDefaultTime="ssTime !== '' && eeTime !== '' ? true : false"
                    />
                  </div>
                </div>
              </div>
            </div>
              

            <!-- Expandable Card for Additional Options -->
            <div class="col-span-2 mt-4">
              <div class="card rounded-lg border border-gray2 bg-white overflow-hidden expandable-card">
                <!-- Card Header - Clickable to expand/collapse -->
                <div
                  @click="showMore = !showMore"
                  class="flex justify-between items-center p-4 cursor-pointer hover:bg-gray-50 transition-colors"
                >
                  <div class="flex items-center">
                    <span class="heading-5 font-semibold text-text1">Additional Options</span>
                    <!-- <span class="ml-2 text-text2 heading-7">(Job Type, Checklist, Items & Tools)</span> -->
                  </div>
                  <i
                    :class="['fa-solid fa-chevron-down text-primary transition-transform duration-300', showMore ? 'rotate-180' : '']"
                  ></i>
                </div>

                <!-- Card Body - Expandable Content -->
                <div v-if="showMore" class="border-t border-gray2">
                  <div class="p-4">
                    <div class="mb-4">
                      <JobItemSelect />
                    </div>
                    <div class="divider mb-4 mt-4"></div>

                    <div class="mb-4">
                      <p v-if="jobCheckList.length > 0" class="label_css mb-2">Job Checklist</p>
                      <div>
                        <div v-if="jobCheckList.length > 0" class="mb-3">
                          <div v-for="(item, ch) in jobCheckList" :key="ch" class="p-3 mb-2 border border-gray2 rounded-lg bg-white">
                            <div class="flex items-center">
                              <!-- <span class="text-primary heading-6 font-semibold mr-2">{{ ch + 1 }}.</span> -->
                              <span class="text-text1 heading-6">{{ item.checkLiTitle }}</span>
                            </div>
                          </div>
                        </div>
                        <div class="flex">
                          <span @click="openChecklistPopup" class="text-primary font-bold cursor-pointer">
                            {{ jobCheckList.length > 0 ? '' : '+' }} Add{{ jobCheckList.length > 0 ? '/Edit' : '' }} Checklist
                          </span>
                          <InfoTooltip tooltipText="Checklist will help you to check things before you leave for the job" position="right" class="ml-2"/>
                        </div>
                      </div>
                    </div>

                    <div class="divider mb-4 mt-4"></div>

                    <div class="mb-4">
                      <p v-if="stepThreeObj.toolList.length > 0" class="label_css mb-2">Tool list:</p>
                      <div>
                        <div v-if="jobCheckList.length > 0" class="mb-3">
                          <div v-for="(tool, ind) in stepThreeObj.toolList" :key="ind" class="p-3 mb-2 border border-gray2 rounded-lg bg-white">
                            <div class="flex items-center">
                              <!-- <span class="text-primary heading-6 font-semibold mr-2">{{ ch + 1 }}.</span> -->
                              <span class="text-text1 heading-6">{{ tool.toolName }}</span>
                            </div>
                          </div>
                        </div>
                        <div class="flex">
                          <span @click="isSelectTool = true" class="text-primary font-bold cursor-pointer">
                            {{ stepThreeObj.toolList.length > 0 ? '' : '+' }} Add{{ stepThreeObj.toolList.length > 0 ? '/Edit above' : '' }} Tools
                          </span>
                          <InfoTooltip tooltipText="Tools will help you to carry tools before you start the day so that you don’t miss anything during the job" position="right" class="ml-2"/>
                        </div>
                      </div>
                    </div>
                    <!-- <div>
                      <p v-if="stepThreeObj.toolList.length > 0" class="text-gray4 heading-4 font-bold mb-2">Tool list:</p>
                      <div v-for="(tool, ind) in stepThreeObj.toolList" :key="ind" class="p-2 mb-2 cust_card">
                        <p class="text-text1">{{ tool.toolName }}</p>
                        <p class="heading-7 text-text2">{{ tool.toolDescription }}</p>
                      </div>
                      <span @click="isSelectTool = true" class="text-primary font-bold cursor-pointer">
                        {{ stepThreeObj.toolList.length > 0 ? '' : '+' }} Add{{ stepThreeObj.toolList.length > 0 ? '/Edit above' : '' }} Tools
                      </span>
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Save and Discard Buttons -->
          <div class="flex justify-end col-span-2 mt-6">
            <div class="text-right flex gap-2">
              <Button
                :btnSize="'medium'"
                :textColor="'text1'"
                :btnColor="'gray1'"
                :btnText="'Cancel'"
                @buttonAction="discardForm"
              />
              <Button
                :btnSize="'medium'"
                :textColor="'white'"
                :btnColor="'success'"
                :btnText="'Save'"
                @buttonAction="saveForm"
                :disabled="custDetail === null"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <AddCustomer v-if="addCustomer" />
    <AddAddressForCreateJob
      v-if="addOther"
      :addJobObj="addJobObj"
      :addressList="addressList"
      @SearchNewAddress="SearchNewAddress"
      @SetLocationCreateJobHanler="SetLocationCreateJobHanler"
    />
    <UpdateCompanyInfo
      v-if="showAddNote"
      :dialogTtile="'Update Hot Notes'"
      :updateCustData="custDetail"
    />
    <AddressAdd :showAdditional="true" v-show="addNewjobAdd" :addedAddress="addedAddress" />
    <SelectTools
      @uppdateToollist="uppdateToollist"
      :toolList="toolMainList"
      @selectToolHandler="selectToolHandler"
      v-if="isSelectTool"
    />
    <SelectChecklist
      :checklist="jobCheckList"
      @checklistHandler="handleChecklistSave"
      v-if="isSelectChecklist"
    />
    <ConfirmBox v-if="isCancelChanges" :warning="false" :cancelbtnText="'Cancel Job'" :confirmBtnText="'Edit Job'" :cancelTextColor="'white'" :rbtnColor="'primary'" :lbtnColor="'error'"
    :message="'You have unsaved changes. Please select an option?'" :title="'Unsaved Changes'" @confirmBoxHandler="handleDiscardConfirm"/>
    <ConfirmBox v-if="showCustomerChangeConfirm" :warning="false"
      :message="'Changing the customer will also change the address to updated customer default address. Do you want to continue?'" :title="'Change Customer'" @confirmBoxHandler="handleCustomerChangeConfirm"/>
  </div>
</template>

<script>
import MyJobApp from "@/api/MyJobApp.js";
import Button from "@/View/components/globalButton.vue";
import TextAreaInput from "@/View/components/textAreaInput.vue";
import SheduleVisit from './components/SheduleVisit.vue';
import timeZoneWithCountryCode from '@/assets/timeZoneWithCountryCode.json';
import milesCountry from '@/assets/milesCountry.json';
import Dropdown from "@/View/components/dropdown.vue";
import TextField from "@/View/components/textfield.vue";
import deboucneMixin from "@/mixins/debounce.js";
import AddCustomer from "../customer/components/AddCustomer.vue";
import UpdateCompanyInfo from "../customer/components/UpdateCompanyInfo.vue";
import AddressAdd from '../components/AddressAdd.vue';
import CheckBoxInput from '../components/checkBoxInput.vue';
import SelectTools from './components/selectTools.vue';
import SelectChecklist from './components/SelectChecklist.vue';
import AddAddressForCreateJob from './components/AddAddressForCreateJob.vue';
import JobItemSelect from './components/JobItemSelect.vue';
import ConfirmBox from '@/View/components/ConfirmBox.vue'
import InfoTooltip from '@/View/components/InfoTooltip.vue'


export default {
  name: "createJob",
  components: {
    Button,
    TextAreaInput,
    SheduleVisit,
    Dropdown,
    TextField,
    AddCustomer,
    UpdateCompanyInfo,
    AddressAdd,
    CheckBoxInput,
    SelectTools,
    SelectChecklist,
    AddAddressForCreateJob,
    JobItemSelect,
    ConfirmBox,
    InfoTooltip
  },
  mixins: [deboucneMixin],
  data() {
    return {
      showMore: false,
      ssTime: '',
      eeTime: '',
      errObj: {
        custErr: "",
        titleErr: "",
        addressErr: "",
      },
      addJobObj: {
        jobId: 0,
        customerId: 0,
        jobNumber: "",
        jobTitle: "",
        jobStartTime: "",
        jobEndTime: "",
        addressLine1: "",
        addressLine2: "",
        city: "",
        state: "",
        zip: "",
        country: "",
        latitude: 0,
        longitude: 0,
        geofenceRangeDiameter: 0,
        fullAddress: "",
        houseNo: "",
        floorNumber: "",
        buildingName: "",
        directionNote: "",
        contactNumber: "",
        contactName: "",
        isAddressAddToCustomer: false,
        requestType: "",
        detailId: 0,
        addressTitle: '',
      },
      stepTwoObj: {
        jobId: 0,
        jobDescription: "",
        isVipJob: false,
        isBillable: false,
        jobTypeId: 0,
        jobEstimation: 0,
        visitCheckList: "",
      },
      stepThreeObj: {
        jobId: 0,
        visitList: [],
        isUnschedule: false,
        assignToList: [],
        itemList: [],
        toolList: [],
      },
      addedAddress: null,
      visitErr: false,
      isSelectTool: false,
      isSelectChecklist: false,
      isAddedNewAddress: false,
      addNewjobAdd: false,
      isOfficeAddressSel: false,
      showAddNote: false,
      jobDisplayAdd: "",
      showAddSelectAddr: false,
      showHotNote: false,
      addCustomer: false,
      custDetail: null,
      isDisable: false,
      resetPaginationValues: false,
      searchForCustomer: "",
      searchApitext: "",
      customersList: [],
      addressList: [],
      jobTypeList: [],
      hourInputValue: 0,
      minInputValue: 0,
      jobDetailObj: null,
      jobCheckList: [],
      displayEstimation: '',
      LoginUserlatLong: null,
      OfficelatLong: null,
      displayDistance: '',
      toolMainList: [],
      timeCounter: 0,
      displayJobTypeName: '',
      otherLocationDistance: '',
      addOther: false,
      assignUser: 0,
      selectedAddress: null,
      selectedAddressLabel: '',
      addressDropdownItems: [],
      isCancelChanges: false,
      isFormDirty: false,
      initialFormState: {},
      showCustomerChangeConfirm: false,
      pendingCustomerData: null
    };
  },
  computed: {},
  created() {
    if (this.$route.query.jobId > 0) {
      this.$router.push({ name: 'jobDetail', params: { jobId: parseInt(this.$route.query.jobId) } });
    }
    if (this.$route.query.requestType) {
      this.addJobObj.requestType = this.$route.query.requestType === 'request' ? this.$route.query.requestType : '';
      this.addJobObj.detailId = this.$route.query.detailId ? Number(this.$route.query.detailId) : 0;
    }
    if (this.$route.query.assignUser) {
      this.assignUser = this.$route.query.assignUser > 0 ? this.$route.query.assignUser : null;
    }
    if (this.$route.query.startTime && this.$route.query.endTime) {
      let sTime = JSON.parse(this.$route.query.startTime);
      let eTime = JSON.parse(this.$route.query.endTime);
      this.ssTime = new Date(sTime);
      this.eeTime = new Date(eTime);
      this.addJobObj.jobStartTime = new Date(sTime);
      this.addJobObj.jobEndTime = new Date(eTime);
    }
  },
  watch: {
    addJobObj: {
      handler() {
        this.isFormDirty = true;
      },
      deep: true
    },
    stepTwoObj: {
      handler() {
        this.isFormDirty = true;
      },
      deep: true
    },
    stepThreeObj: {
      handler() {
        this.isFormDirty = true;
      },
      deep: true
    },
    jobCheckList: {
      handler() {
        this.isFormDirty = true;
      },
      deep: true
    },
    selectedAddress() {
      this.isFormDirty = true;
    }
  },
  mounted() {
    // Ensure scroll is enabled when navigating to this page
    document.body.style.overflow = 'auto';
    document.documentElement.style.overflow = 'auto';
    this.$nextTick(() => {
      this.saveInitialFormState();
    });
    if (this.$route.query.jobId > 0) {
      this.getsJobDetail(true);
    }
    this.LoginUserlatLong = JSON.parse(localStorage.getItem('LoginUserlatLong'));
    this.OfficelatLong = JSON.parse(localStorage.getItem('orgInfo'));
    if (this.$route.query.customerId > 0) {
      this.isDisable = true;
      this.getCustLeadInfo(parseInt(this.$route.query.customerId));
    }
    this.$root.$on("createjobAddressHandler", (response, data) => {
      if (response && data !== null && this.addOther) {
        this.setAddress(data, false);
      }
      this.addOther = false;
    });
    this.$root.$on('EditAddressHandler', () => {
      if (this.addNewjobAdd) {
        this.addNewjobAdd = false;
      }
    });
    this.$root.$on("addAddressHandler", (response, data) => {
      if (response && data !== null && this.addNewjobAdd) {
        this.setAddress(data);
        this.addOther = false;
      }
      this.addNewjobAdd = false;
    });
    this.getCustomerList();
    this.getToolList();
    this.jobTypelist();
    this.$root.$on("updateCustHandler", (response) => {
      this.showAddNote = false;
      if (response) {
        this.getCustDetails(this.custDetail.customerId);
      }
    });
    this.$root.$on("addCustomerHandler", (response, data) => {
      if (response && this.addCustomer) {
        this.selectNewCustomer(data);
      }
      this.addCustomer = false;
    });
    this.getCustList = this.debounce(function () {
      this.getCustomerList();
    }, 500);
    this.$root.$on('finalvisitlistHandler', (response) => {
      if (response[0].isUnschedule) {
        this.stepThreeObj.visitList = [];
        this.stepThreeObj.isUnschedule = true;
      } else {
        this.stepThreeObj.visitList = response;
        this.stepThreeObj.isUnschedule = false;
      }
      this.visitErr = false;
    });
    this.$root.$on('setSelectedEmpHandler', (response) => {
      this.stepThreeObj.assignToList = response;
    });
    this.$root.$on('setItemSelectedHandler', (response) => {
      console.log("this.stepThreeObj.itemList", this.stepThreeObj.itemList)
      this.stepThreeObj.itemList = response;
    });
  },
  beforeDestroy() {
    this.$root.$off("updateCustHandler");
    this.$root.$off("addCustomerHandler");
    this.$root.$off("setItemSelectedHandler");
    this.$root.$off("addAddressHandler");
    this.$root.$off("finalvisitlistHandler");
    this.$root.$off("setSelectedEmpHandler");
    this.$root.$off("createjobAddressHandler");
    this.$root.$off("EditAddressHandler");
  },
  methods: {
    SearchNewAddress(isActive) {
      this.addNewjobAdd = isActive;
    },
    SetLocationCreateJobHanler() {
      this.addOther = false;
    },
    saveInitialFormState() {
      this.initialFormState = JSON.parse(JSON.stringify({
        customerId: this.addJobObj.customerId,
        jobTitle: this.addJobObj.jobTitle,
        // Billing
        isBillable: this.stepTwoObj.isBillable,
        // VIP flag
        isVipJob: this.stepTwoObj.isVipJob,
        // Description
        jobDescription: this.stepTwoObj.jobDescription,
        // Address (any address field filled)
        addressLine1: this.addJobObj.addressLine1,
        addressLine2: this.addJobObj.addressLine2,
        city: this.addJobObj.city,
        state: this.addJobObj.state,
        zip: this.addJobObj.zip,
        // "Add address to customer" checkbox
        isAddressAddToCustomer: this.addJobObj.isAddressAddToCustomer
      }));
      console.log("initialFormState", this.initialFormState)
      this.isFormDirty = false;
    },
    checkIfFormIsDirty() {
      const current = {
        customerId: this.addJobObj.customerId,
        jobTitle: this.addJobObj.jobTitle,
        isBillable: this.stepTwoObj.isBillable,
        isVipJob: this.stepTwoObj.isVipJob,
        jobDescription: this.stepTwoObj.jobDescription,
        addressLine1: this.addJobObj.addressLine1,
        addressLine2: this.addJobObj.addressLine2,
        city: this.addJobObj.city,
        state: this.addJobObj.state,
        zip: this.addJobObj.zip,
        isAddressAddToCustomer: this.addJobObj.isAddressAddToCustomer
      };
      console.log("current", current)
      return JSON.stringify(current) !== JSON.stringify(this.initialFormState);
    },
    uppdateToollist(data) {
      this.toolMainList.push(data);
    },
    selectToolHandler(data) {
      if (data !== null) {
        this.stepThreeObj.toolList = data;
      }
      this.isSelectTool = false;
    },
    deleteCheckItem(index) {
      this.jobCheckList.splice(index, 1);
    },
    addcheckLiItem() {
      this.jobCheckList.push({ checkLiTitle: '' });
    },
    openChecklistPopup() {
      this.isSelectChecklist = true;
    },
    handleChecklistSave(checklist) {
      if (checklist !== null) {
        this.jobCheckList = checklist;
      }
      this.isSelectChecklist = false;
    },
    addNewAddress() {
      this.addOther = true;
    },
    callsearchCust(text) {
      this.searchApitext = text;
      this.getCustList();
    },
    getCustomerList() {
      this.customersList = [];
      MyJobApp.getGlobalCustLeadList(
        0,
        500,
        this.searchApitext,
        "",
        (response) => {
          let tempList = response.Data.tableRow !== null ? response.Data.tableRow : [];
          tempList.forEach((e) => {
            let lead = e.isLead ? "(lead)" : "(customer)";
            e.companyName = e.companyName + " " + lead;
            this.customersList.push(e);
          });
          this.$store.dispatch("SetLoader", { status: false, message: "" });
        },
        () => {
          this.resetPaginationValues = false;
          this.$store.dispatch("SetLoader", { status: false, message: "" });
        }
      );
    },
    addNewCustomer() {
      this.addCustomer = true;
    },
    selectNewCustomer(data) {
      // If customer is already selected and user is trying to change it, show confirmation
      if (data !== null && this.addJobObj.customerId > 0 && this.addJobObj.customerId !== data.customerId) {
        this.pendingCustomerData = data;
        this.showCustomerChangeConfirm = true;
        return;
      }

      this.applyCustomerChange(data);
    },
    applyCustomerChange(data) {
      this.errObj.addressErr = "";
      if (data !== null) {
        this.islead = data.isLead;
        this.jobDisplayAdd = "";
        this.addJobObj.addressLine1 = "";
        this.addJobObj.addressTitle = "";
        this.addJobObj.addressLine2 = "";
        this.addJobObj.city = "";
        this.addJobObj.state = "";
        this.addJobObj.zip = "";
        this.addJobObj.latitude = 0;
        this.addJobObj.longitude = 0;
        this.addJobObj.country = "";
        this.addJobObj.directionNote = "";
        this.addJobObj.houseNo = "";
        this.addJobObj.floorNumber = "";
        this.addJobObj.buildingName = "";
        this.addressList = [];
        this.addressDropdownItems = [];
        this.selectedAddress = null;
        this.selectedAddressLabel = '';
        this.isOfficeAddressSel = false;
        this.isAddedNewAddress = false;
        this.errObj.custErr = "";
        this.searchForCustomer = data.companyName;
        this.addJobObj.customerId = data.customerId;
        this.showAddSelectAddr = true;
        this.getCustDetails(data.customerId);
      } else {
        this.searchForCustomer = "";
        this.addJobObj.customerId = 0;
        this.custDetail = null;
        this.showAddSelectAddr = false;
        this.selectedAddress = null;
        this.selectedAddressLabel = '';
        this.addressDropdownItems = [];
        this.addressList = [];
      }
    },
    getCustLeadInfo(custId) {
      this.$store.dispatch("SetLoader", { status: true, message: "Loading..." });
      MyJobApp.getCustomerDetail(
        custId,
        (response) => {
          this.searchForCustomer = response.Data.companyName;
          this.addJobObj.customerId = response.Data.customerId;
          this.showAddSelectAddr = true;
          this.getCustDetails(response.Data.customerId);
          this.$store.dispatch("SetLoader", { status: false, message: "" });
        },
        () => {
          this.$store.dispatch("SetLoader", { status: false, message: "" });
        }
      );
    },
    setCustomerDetail() {
      this.searchForCustomer = this.custDetail.companyName;
      this.addressDropdownItems = []; // Reset
      this.addressList = [];

      // ---------- 1. Customer addresses ----------
        if (this.custDetail.addressList && this.custDetail.addressList.length) {
          this.custDetail.addressList.forEach(e => {
            let dist = 0;
            let suffix = '';
            if (this.LoginUserlatLong) {
              dist = this.calcDistance(
                this.LoginUserlatLong.latitude,
                this.LoginUserlatLong.longitude,
                e.latitude,
                e.longitude
              );
              suffix = ' from user';
            } else if (this.OfficelatLong) {
              dist = this.calcDistance(
                this.OfficelatLong.latitude,
                this.OfficelatLong.longitude,
                e.latitude,
                e.longitude
              );
              suffix = ' from office';
            }
            const distanceLabel = this.getDistanceUnit(dist * 1000) + suffix;

            const addrObj = {
              ...e,
              selected: false,
              displayDistance: distanceLabel,
              addressText: `(${e.addressTitle || 'Other'}) - ${e.fullAddress}`
            };

            this.addressList.push(addrObj);

            // <-- push into dropdown
            this.addressDropdownItems.push({
              label: addrObj.addressText,
              value: { type: 'customer', data: addrObj }
            });
          });
        }

        // ---------- 2. Office location ----------
        this.addressDropdownItems.push({
          label: 'Office Location',
          value: { type: 'office' }
        });

        // ---------- 3. Auto-select first item ----------
        if (this.addressDropdownItems.length && !this.selectedAddress) {
          this.$nextTick(() => {
            this.handleAddressSelect(this.addressDropdownItems[0]);
          });
        }
    },

    handleAddressSelect(item) {
      console.log("handleAddressSelect - full item:", item);

      // Extract the value from the item
      const selected = item ? item.value : null;

      this.errObj.addressErr = "";

      if (!selected) {
        this.selectedAddress = null;
        this.selectedAddressLabel = '';
        this.resetAddressFields();
        return;
      }

      // Now selected is { type: 'customer', data: ... } or { type: 'office' }
      this.selectedAddress = selected;

      this.selectedAddressLabel = selected.type === 'customer'
        ? (selected.data.addressTitle || 'Other')
        : 'Office Location';

      if (selected.type === 'customer') {
        this.selectJobAddress(selected.data, -1);
        this.isOfficeAddressSel = false;
        this.isAddedNewAddress = false;
      } else if (selected.type === 'office') {
        this.checkboxCheck();
        this.isOfficeAddressSel = true;
        this.isAddedNewAddress = false;
      }
    },

  resetAddressFields() {
    this.addJobObj.addressLine1 = "";
    this.addJobObj.addressLine2 = "";
    this.addJobObj.city = "";
    this.addJobObj.state = "";
    this.addJobObj.zip = "";
    this.addJobObj.latitude = 0;
    this.addJobObj.longitude = 0;
    this.addJobObj.fullAddress = "";
    this.addJobObj.addressTitle = "";
    this.isOfficeAddressSel = false;
    this.isAddedNewAddress = false;
  },
  getAddressLabel(addr) {
    if (!addr || !addr.value) return '';
    const val = addr.value;

    if (val.type === 'customer') {
      return val.data.addressTitle === '' ? 'Other' : val.data.addressTitle;
    } else if (val.type === 'office') {
      return 'Office Location';
    } else if (val.type === 'new') {
      return '+ Add Other Location';
    }
    return '';
  },
    getCustDetails(custId) {
      MyJobApp.getCustomerDetail(
        custId,
        (response) => {
          this.custDetail = response.Data;
          this.setCustomerDetail();
          this.$store.dispatch("SetLoader", { status: false, message: "" });
        },
        () => {
          this.$store.dispatch("SetLoader", { status: false, message: "" });
        }
      );
    },
    setAddress(data, isNotNew) {
      if (!isNotNew) {
        this.isAddedNewAddress = true;
        let temp = 0;
        let temp3 = '';
        if (this.LoginUserlatLong !== null) {
          temp = this.calcDistance(this.LoginUserlatLong.latitude, this.LoginUserlatLong.longitude, data.latitude, data.longitude);
          temp3 = ` from user`;
        } else {
          temp = this.calcDistance(this.OfficelatLong.latitude, this.OfficelatLong.longitude, data.latitude, data.longitude);
          temp3 = ` from office`;
        }
        let value = this.getDistanceUnit(temp * 1000);
        this.otherLocationDistance = value + temp3;
        this.isOfficeAddressSel = false;
        this.addJobObj.isAddressAddToCustomer = true;
        this.addressList.forEach(e => { e.selected = false; });
      }
      this.jobDisplayAdd = data !== null ? data.fullAddress : "";
      this.addJobObj.addressTitle = data !== null ? data.addressTitle : "";
      this.addJobObj.addressLine1 = data !== null ? data.addressLine1 : "";
      this.addJobObj.addressLine2 = data !== null ? data.addressLine2 : "";
      this.addJobObj.city = data !== null ? data.city : "";
      this.addJobObj.state = data !== null ? data.state : "";
      this.addJobObj.zip = data !== null ? data.zip : "";
      this.addJobObj.latitude = data !== null ? data.latitude : 0;
      this.addJobObj.longitude = data !== null ? data.longitude : 0;
      this.addJobObj.country = data !== null ? data.country : "";
      this.addJobObj.geofenceRangeDiameter = data !== null ? data.selectedRadius : "";
      this.addJobObj.fullAddress = data !== null ? data.fullAddress : "";
      this.addJobObj.houseNo = data !== null ? data.houseNo : "";
      this.addJobObj.floorNumber = data !== null ? data.floorNumber : "";
      this.addJobObj.buildingName = data !== null ? data.buildingName : "";
      this.addJobObj.directionNote = data !== null ? data.directionNote : "";
      this.addJobObj.contactNumber = data !== null ? data.contactNumber : "";
      this.addJobObj.contactName = data !== null ? data.contactName : "";
      if (this.LoginUserlatLong !== null) {
        let dist = this.calcDistance(this.LoginUserlatLong.latitude, this.LoginUserlatLong.longitude, data.latitude, data.longitude);
        let final = this.getDistanceUnit(dist * 1000);
        this.displayDistance = final + ' from user';
      } else if (this.OfficelatLong !== null) {
        let dist = this.calcDistance(this.addJobObj.latitude, this.addJobObj.longitude, this.OfficelatLong.latitude, this.OfficelatLong.longitude);
        let final = this.getDistanceUnit(dist * 1000);
        this.displayDistance = final + ' from Office';
      }
    },
    selectJobAddress(data, index) {
      this.isOfficeAddressSel = false;
      this.addressList.forEach((e, i) => {
        e.selected = index === i;
      });
      this.isAddedNewAddress = false;
      this.addedAddress = null;
      this.addJobObj.isAddressAddToCustomer = false;
      this.jobDisplayAdd = data !== null ? data.addressText : "";
      this.addJobObj.addressTitle = data !== null ? data.addressTitle : "";
      this.addJobObj.fullAddress = data !== null ? data.fullAddress : "";
      this.addJobObj.addressLine1 = data !== null ? data.addressLine1 : "";
      this.addJobObj.addressLine2 = data !== null ? data.addressLine2 : "";
      this.addJobObj.city = data !== null ? data.city : "";
      this.addJobObj.state = data !== null ? data.state : "";
      this.addJobObj.zip = data !== null ? data.zip : "";
      this.addJobObj.latitude = data !== null ? data.latitude : 0;
      this.addJobObj.longitude = data !== null ? data.longitude : 0;
      this.addJobObj.country = data !== null ? data.country : "";
      this.addJobObj.directionNote = data !== null ? data.directionNote : "";
      this.addJobObj.houseNo = data !== null ? data.houseNo : "";
      this.addJobObj.floorNumber = data !== null ? data.floorNumber : "";
      this.addJobObj.buildingName = data !== null ? data.buildingName : "";
    },
    checkboxCheck() {
      this.addressList.forEach(e => { e.selected = false; });
      this.isOfficeAddressSel = true;
      this.isAddedNewAddress = false;
      this.addedAddress = null;
      this.errObj.addressErr = "";
      this.jobDisplayAdd = "";
      this.addJobObj.isAddressAddToCustomer = false;
      this.addJobObj.fullAddress = "";
      this.addJobObj.addressTitle = "";
      this.addJobObj.addressLine1 = "";
      this.addJobObj.addressLine2 = "";
      this.addJobObj.city = "";
      this.addJobObj.state = "";
      this.addJobObj.zip = "";
      this.addJobObj.latitude = 0;
      this.addJobObj.longitude = 0;
      this.addJobObj.country = "";
      this.addJobObj.directionNote = "";
      this.addJobObj.houseNo = "";
      this.addJobObj.floorNumber = "";
      this.addJobObj.buildingName = "";
      if (!this.isOfficeAddressSel) {
        this.getCustDetails(this.addJobObj.customerId);
      }
    },
    saveForm() {
      
      let isValid = true;
      if (this.addJobObj.jobTitle.trim() === "") {
        this.errObj.titleErr = "Job title is required";
        isValid = false;
      }
      if (this.addJobObj.customerId === 0) {
        this.errObj.custErr = "Please select customer";
        isValid = false;
      }
      // if (!this.isOfficeAddressSel && this.addJobObj.latitude === 0 && this.addJobObj.longitude === 0) {
      //   this.errObj.addressErr = "Please select or add address";
      //   isValid = false;
      // }
      if (isValid) {
        this.$store.dispatch("SetLoader", { status: true, message: "Loading..." });
        if (this.addJobObj.jobStartTime === '' && this.addJobObj.jobEndTime === '') {
          this.addJobObj.jobStartTime = new Date().toUTCString();
          let currentDate = new Date();
          currentDate.setHours(currentDate.getHours() + 1);
          this.addJobObj.jobEndTime = new Date(currentDate).toUTCString();
        }
        console.log("this.addJobObj", this.addJobObj)
        console.log("this.stepTwoObj", this.stepTwoObj)
        console.log("this.stepThreeObj", this.stepThreeObj)
        // Step 1: Save job basic details
        MyJobApp.addNewJobStepOne(
          this.addJobObj,
          (response) => {
            
            this.addJobObj.jobId = response.Data;
            this.stepTwoObj.jobId = response.Data;
            this.stepThreeObj.jobId = response.Data;
            // Step 2: Save description and job type
            let list = this.jobCheckList.filter(item => item.checkLiTitle.trim() !== '');
            this.stepTwoObj.visitCheckList = JSON.stringify(list);
            this.stepTwoObj.jobEstimation = 1440;
            MyJobApp.updateJobStep2(
              this.stepTwoObj,
              () => {
                // Step 3: Save schedule and assignee
                MyJobApp.updateJobStep3(
                  this.stepThreeObj,
                  () => {
                    this.$store.dispatch("SetLoader", { status: false, message: "" });
                    this.$store.dispatch("SetAlert", {
                      showAlert: true,
                      message: "Job created successfully",
                      color: "success",
                    });
                    this.saveInitialFormState();
                    this.$router.push({ name: 'jobDetail', params: { jobId: this.addJobObj.jobId } });
                  },
                  (error) => {
                    this.$store.dispatch("SetAlert", { showAlert: true, message: error.message, color: "error" });
                    this.$store.dispatch("SetLoader", { status: false, message: "" });
                  }
                );
              },
              (error) => {
                this.$store.dispatch("SetAlert", { showAlert: true, message: error.message, color: "error" });
                this.$store.dispatch("SetLoader", { status: false, message: "" });
              }
            );
          },
          (error) => {
            this.$store.dispatch("SetAlert", { showAlert: true, message: error.message, color: "error" });
            this.$store.dispatch("SetLoader", { status: false, message: "" });
          }
        );
      }
    },
    discardForm() {
      if (this.checkIfFormIsDirty()) {
        this.isCancelChanges = true;
      } else {
        this.$router.go(-1);
      }
    },
    handleDiscardConfirm(confirmed) {
      console.log("handleDiscardConfirm - confirmed:", confirmed);
      if (!confirmed) {
        this.$router.go(-1); // Only go back if user clicked "Yes"
      }
      document.body.style = 'overflow: visible;';
      this.isCancelChanges = false;
    },
    handleCustomerChangeConfirm(confirmed) {
      if (confirmed) {
        // User confirmed, apply the customer change
        this.applyCustomerChange(this.pendingCustomerData);
      } else {
        // User cancelled, reset the dropdown to previous customer
        if (this.custDetail) {
          this.searchForCustomer = this.custDetail.companyName;
        }
      }
      // Reset confirmation state
      this.showCustomerChangeConfirm = false;
      this.pendingCustomerData = null;
      document.body.style = 'overflow: visible;';
    },
    selectJobType(data) {
      this.jobCheckList = JSON.parse(data.jobCheckList);
      this.hourInputValue = 1440;
      this.minInputValue = 0;
      this.stepTwoObj.jobTypeId = data.jobTypeId;
      this.displayJobTypeName = data.jobTypeName;
      this.setDisplayEstimation();
    },
    setDisplayEstimation() {
      this.displayEstimation = '24 Hr';
    },
    getsJobDetail(callCustomer) {
      this.$store.dispatch("SetLoader", { status: true, message: "Loading..." });
      MyJobApp.getJobDetail(
        parseInt(this.$route.query.jobId),
        (response) => {
          this.jobDetailObj = response.Data;
          this.displayJobTypeName = response.Data.jobTypeName;
          this.stepTwoObj.isBillable = response.Data.isBillable;
          this.stepTwoObj.isVipJob = response.Data.isVipJob;
          this.stepTwoObj.jobDescription = response.Data.jobDescription;
          this.stepTwoObj.jobTypeId = response.Data.jobTypeId;
          this.stepTwoObj.jobId = response.Data.jobId;
          this.stepThreeObj.jobId = response.Data.jobId;
          this.stepTwoObj.jobEstimation = response.Data.jobEstimation;
          this.hourInputValue = Math.floor(response.Data.jobEstimation / 60);
          this.minInputValue = response.Data.jobEstimation % 60;
          this.setAddress(response.Data, true);
          this.addJobObj.jobId = response.Data.jobId;
          this.addJobObj.customerId = response.Data.customerId;
          this.addJobObj.jobTitle = response.Data.jobTitle;
          this.addJobObj.isAddressAddToCustomer = false;
          this.addJobObj.addressTitle = response.Data.addressTitle;
          this.showAddSelectAddr = true;
          if (callCustomer) {
            this.getCustDetails(parseInt(response.Data.customerId));
          }
          this.setDisplayEstimation();
          if (this.jobDetailObj) {
            this.jobTypeList.forEach(element => {
              if (element.jobTypeId === this.jobDetailObj.jobTypeId) {
                this.jobCheckList = JSON.parse(element.jobCheckList);
              }
            });
          }
          this.$store.dispatch("SetLoader", { status: false, message: "" });
        },
        (err) => {
          this.$store.dispatch("SetAlert", { showAlert: true, message: err.message, color: "error" });
          this.$store.dispatch("SetLoader", { status: false, message: "" });
        }
      );
    },
    jobTypelist() {
      MyJobApp.jobTypelist(
        (response) => {
          this.jobTypeList = response.Data;
          // Select the default job type if it exists
          let defaultType = this.jobTypeList.find(type => type.IsDefault === true);
          if (defaultType) {
            this.selectJobType(defaultType);
          }
          if (this.jobDetailObj) {
            this.jobTypeList.forEach(element => {
              if (element.jobTypeId === this.jobDetailObj.jobTypeId) {
                this.jobCheckList = JSON.parse(element.jobCheckList);
              }
            });
          }
        },
        (err) => {
          this.$store.dispatch("SetAlert", { showAlert: true, message: err.message, color: "error" });
          this.$store.dispatch("SetLoader", { status: false, message: "" });
        }
      );
    },
    calculateDistance(lat1, lon1, lat2, lon2, unit) {
      if (lat1 === lat2 && lon1 === lon2) {
        return 0;
      }
      const radlat1 = (Math.PI * lat1) / 180;
      const radlat2 = (Math.PI * lat2) / 180;
      const theta = lon1 - lon2;
      const radtheta = (Math.PI * theta) / 180;
      let dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
      if (dist > 1) {
        dist = 1;
      }
      dist = Math.acos(dist);
      dist = (dist * 180) / Math.PI;
      dist = dist * 60 * 1.1515;
      if (unit === 'K') {
        dist *= 1.609344;
      }
      if (unit === 'N') {
        dist *= 0.8684;
      }
      return dist;
    },
    getToolList() {
      MyJobApp.getToolList(
        (response) => {
          response.Data.forEach(element => {
            this.toolMainList.push({ ...element, selected: false });
          });
        },
        () => {
          this.$store.dispatch("SetLoader", { status: false, message: "" });
        }
      );
    },
    getDistanceUnit(distanceMeter) {
      let distance = '';
      let countryCode;
      const moment = require('moment-timezone');
      const countryTimeZone = moment.tz.guess();
      timeZoneWithCountryCode.map(itm => {
        const ind = itm.timezones.findIndex(x => x.name === countryTimeZone);
        if (ind >= 0) {
          countryCode = itm.code;
        }
      });
      const index = milesCountry.findIndex(x => x.countryCode === countryCode);
      if (index >= 0) {
        if (distanceMeter * 0.00062137 >= 1000) {
          distance = `999+ mi`;
        } else if (distanceMeter * 0.00062137 < 0.1) {
          distance = '';
        } else {
          distance = `${(distanceMeter * 0.00062137).toFixed(1)} mi`;
        }
      } else if (distanceMeter / 1000 >= 1000) {
        distance = `999+ km`;
      } else if (distanceMeter / 1000 < 0.1) {
        distance = '';
      } else {
        distance = `${(distanceMeter / 1000).toFixed(1)} km`;
      }
      return distance;
    },
    calcDistance(lat1, lon1, lat2, lon2) {
      const radius = 6371;
      const dLat = this.toRadians(lat2 - lat1);
      const dLng = this.toRadians(lon2 - lon1);
      const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(this.toRadians(lat1)) * Math.cos(this.toRadians(lat2)) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      const distance = radius * c;
      return distance.toFixed(2);
    },
    toRadians(degree) {
      return degree * (Math.PI / 180);
    },
  },
};
</script>
<style scoped>
.expandable-card {
  /* box-shadow: none !important; */
}
</style>